import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class MapSearchBox extends Component {
  static propTypes = {
    mapsapi: PropTypes.shape({
      places: PropTypes.shape({
        SearchBox: PropTypes.func
      }),
      event: PropTypes.shape({
        clearInstanceListeners: PropTypes.func
      })
    }).isRequired,
    placeholder: PropTypes.string,
    onPlacesChanged: PropTypes.func
  }

  static defaultProps = {
    placeholder: 'Search...',
    onPlacesChanged: null
  }

  constructor(props) {
    super(props)

    this.searchInput = React.createRef()
  }

  componentDidMount() {
    const { places } = this.props.mapsapi

    this.searchBox = new places.SearchBox(this.searchInput.current)
    this.searchBox.addListener('places_changed', this.onPlacesChanged)
  }

  componentWillUnmount() {
    const {
      mapsapi: { event }
    } = this.props

    event.clearInstanceListeners(this.searchBox)
  }

  onPlacesChanged = () => {
    const { onPlacesChanged } = this.props

    if (onPlacesChanged) {
      onPlacesChanged(this.searchBox.getPlaces())
    }
  }

  render() {
    const { placeholder } = this.props

    return (
      <input
        ref={this.searchInput}
        placeholder={placeholder}
        type="text"
        style={{
          width: '200px',
          fontSize: '16px',
          border: 'none',
          position: 'absolute',
          bottom: '320px',
          right: '10px',
          height: '0px',
          padding: '20px',
          textOverflow: 'ellipsis'
        }}
      />
    )
  }
}
